// extracted by mini-css-extract-plugin
module.exports = {"SimpleLoadingIndicator":"SimpleLoadingIndicator_SimpleLoadingIndicator___OqI6"};